<template>
  <div 
    class="mt-5">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <div>
                
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          v-if="dialog.form"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center px-4 py-2 text-right popup-header">
              <div
                class="fs-16 font_weight_700">
                {{ form.id === '' ? 'Tambah' : 'Ubah' }} {{ $route.meta.title }}
              </div>

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon> -->

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="22"
                color="#9ca3af">
                mdi-close
              </v-icon>
            </v-card-title>

            <v-divider 
              class="mt-0"
              style="border-top: 1px solid #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider 
                    name="Sekolah"
                    rules="required"  
                    v-slot="{ errors }">
                    <div class="fs-13 mb-1">
                      
                      Sekolah
                      <span class="red--text">*</span>
                    </div>

                    <v-autocomplete
                      v-on:keyup.enter="save()"

                      solo
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. SMP xxxxx"

                      :readonly="user.school_id !== undefined && user.school_id !== null"

                      :items="school"
                      item-text="name"
                      item-value="id"
                      :item-color="set_color"

                      v-model="form.school_id"
                      class="mb-0"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-autocomplete>
                  </ValidationProvider>


                  <ValidationProvider 
                    name="Nama Role" 
                    rules="required" 
                    v-slot="{ errors }">
                    <div class="fs-13 mb-1 black--text">
                      
                      Nama Role
                      <span class="red--text">*</span>
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      solo
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. Admin"

                      

                      v-model="form.category_name"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;"
                      class="mb-0">
                    </v-text-field>
                  </ValidationProvider>

                  <div class="fs-13 mb-1 black--text">
                    Menu Akses
                  </div>
                  <div style="max-height: 400px; overflow-y: auto;">
                    <div v-for="(item, index) in menu" :key="index">
                      <div class="d-flex align-center pb-3">
                        <div @click="item.status = !item.status" class="cursor-pointer">
                          <v-avatar
                            tile
                            size="16">
                            <v-img contain :src="item.icon"></v-img>
                          </v-avatar>
                        </div>
                        <div class="ml-2 fs-13 cursor-pointer" @click="item.status = !item.status">
                          {{ item.label }}
                        </div>

                        <div class="ml-auto">
                          <v-checkbox
                            v-model="item.status"
                            :color="set_color"
                            hide-details
                            dense
                            class="mt-0 pt-0">
                          </v-checkbox>
                        </div>

                      </div>

                      <div v-if="item.sub_menu.length > 0 && item.status">
                        <div v-for="(sub, idx) in item.sub_menu" :key="idx" class="ml-4">
                          <div class="d-flex align-center pb-3">
                            <div @click="sub.status = !sub.status" class="cursor-pointer">
                              <v-avatar
                                tile
                                size="16">
                                <v-img contain :src="sub.icon"></v-img>
                              </v-avatar>
                            </div>
                            <div class="ml-2 fs-13 cursor-pointer" @click="sub.status = !sub.status">
                              {{ sub.label }}
                            </div>

                            <div class="ml-auto">
                              <v-checkbox
                                v-model="sub.status"
                                :color="set_color"
                                hide-details
                                dense
                                class="mt-0 pt-0">
                              </v-checkbox>
                            </div>
                          </div>

                          <div v-if="sub.sub_menu.length > 0 && sub.status">
                            <div v-for="(sub2, idx2) in sub.sub_menu" :key="idx2" class="ml-6">
                              <div class="d-flex align-center pb-3">
                                <div @click="sub2.status = !sub2.status" class="cursor-pointer">
                                  <v-icon
                                    size="15"
                                    :color="'black'">
                                    mdi-minus
                                  </v-icon>
                                </div>
                                <div class="ml-2 fs-13 cursor-pointer" @click="sub2.status = !sub2.status">
                                  {{ sub2.label }}
                                </div>

                                <div class="ml-auto">
                                  <v-checkbox
                                    v-model="sub2.status"
                                    :color="set_color"
                                    hide-details
                                    dense
                                    class="mt-0 pt-0">
                                  </v-checkbox>
                                </div>
                              </div>

                              <div v-if="sub2.sub_menu.length > 0 && sub2.status">
                                <div v-for="(sub3, idx3) in sub2.sub_menu" :key="idx3" class="ml-9">
                                  <div class="d-flex align-center pb-3">
                                    <div @click="sub3.status = !sub3.status" class="cursor-pointer">
                                      <v-icon
                                        size="15"
                                        :color="'black'">
                                        mdi-minus
                                      </v-icon>
                                    </div>
                                    <div class="ml-2 fs-13 cursor-pointer" @click="sub3.status = !sub3.status">
                                      {{ sub3.label }}
                                    </div>

                                    <div class="ml-auto">
                                      <v-checkbox
                                        v-model="sub3.status"
                                        :color="set_color"
                                        hide-details
                                        dense
                                        class="mt-0 pt-0">
                                      </v-checkbox>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                      
                    </div>
                  </div>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 1px solid #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="85"
                elevation="0"
                :color="set_color"
                style="border-radius: 6px;"
                class="fs-13 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="85"
                outlined
                elevation="0"
                color="red"
                style="border-radius: 6px;"
                class="fs-13 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
  
        <section>
          <v-row
            class="pa-4 pb-0 pt-0">
            <v-col
              cols="12" class="pb-1 pt-1">
              <v-card
                flat
                color="#ffffff">
                <v-card-text>
                  <div
                    class="d-flex align-center">
                    <div
                      class="d-flex align-center">
                      <v-avatar
                        tile
                        size="22">
                        <v-icon
                          :color="set_color"
                          size="18">
                          mdi-menu
                        </v-icon>
                        <!-- <v-img
                          contain
                          alt="kominfoklaten"  
                          :src="require('@/assets/image/grip_menu.png')">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img> -->
                      </v-avatar>
  
                      <span
                        class="fs-16 black--text ml-2"
                        style="font-weight: 600;">
                        {{ $route.meta.title }}
                      </span>
                    </div>
  
                    <v-spacer />
  
                    <div class="d-flex align-center">
                      <v-text-field
                        @click:clear="search = ''; fetch();"
                        v-on:keyup.enter="fetch()"
            
                        solo
                        rounded
                        dense
                        single-line
            
                        hide-details
                        :color="set_color"
                        placeholder="Cari data . . ."
                        prepend-inner-icon="mdi-magnify"
                        clearable
            
                        v-model="search"
                        class="fs-12 little-placeholder"
                        style="border-radius: 6px; background: #fff !important; max-width: 320px">
                      </v-text-field>
                      <v-autocomplete
                        v-on:change="fetch()"
            
                        solo
                        rounded
                        dense
                        single-line
            
                        hide-details
                        v-if="(user.school_id === undefined || user.school_id === null) &&($store.state.school === null || $store.state.school === undefined || undefined === '')"
                        :color="set_color"
                        placeholder="Pilih Sekolah"
                        prepend-inner-icon="mdi-magnify"
                        :items="school"
                        item-text="name"
                        item-value="id"
            
                        v-model="filter.school_id"
                        class="fs-12 little-placeholder ml-3"
                        style="border-radius: 6px; background: #fff !important; max-width: 400px">
                      </v-autocomplete>
                      <v-btn
                        @click="dialog.form = true; reset();"
                        :color="set_color"
                        elevation="0"
                        small
                        min-height="36"
                        class="fs-12 white--text text-capitalize d-flex align-center ml-3"
                        style="border-radius: 6px; font-weight: 600;">
                        <span
                          class="ml-0">
                          Tambah
                        </span>
                      </v-btn>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 6px;">
                <v-card-text v-if="filter.school_id === '' || filter.school_id === null">
                    <div
                      class="d-flex align-center justify-center" style="height: calc(100vh - 250px);">
                      <div>
                        <v-img 
                          class="mx-auto"
                          contain
                          alt="vuetify"
                          :width="100"
                          :height="100"
                          :src="require('@/assets/icon/selective.png')">
                          <template v-slot:placeholder>
                            <v-row
                              class=" "
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
    
                        <div 
                          class="font-weight-light text-second my-6">
                          Pilih <b>Sekolah</b> terlebih dahulu!!!
                        </div>
                      </div>
                    </div>

                  </v-card-text>
                  <v-card-text v-if="filter.school_id !== '' && filter.school_id !== null">
                  <v-data-table
                    v-model="selected.row"
                    ref="table-grid"
                    class="table-grid"
                    :height="`calc(100vh - ${pagination.total_data > 0 ? '315px' : '248px'})`"
                    :show-select="checkbox"
                    :single-select="true"
                    :loading="process.load"
                    loading-text="Sedang memuat data . . ."
                    loader-height="5"
                    no-results-text="Belum ada data"
                    :options.sync="options"
                    :headers="configHeaders"
                    :items="list"
                    :items-per-page="100"
                    item-key="id"
                    @click:row="rowClick"
                    @toggle-select-all="handleToggleAll($event)"
                    @dblclick:row="doubleClick"
                    hide-default-footer
                    hide-default-header>
                    <template v-slot:header="{ props: { headers } }">
                      <thead>
                        <tr>
                          <th v-for="h in headers" :key="h" :style="`min-width: ${h.width === '' ? '' : h.width }; width: ${h.width === '' ? '' : h.width };background-color: #f3f4f6 !important; color: #000 !important;`" :class="`text-${h.align}`">
                            <span>{{h.text}}</span>
                          </th>
                        </tr>
                      </thead>
                    </template>
                    <template
                      v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                      v-slot:[`item.${header.value}`]="{ value, index, item }">
                      <div
                        v-bind:key="header.value">
                        <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                          {{ rowFormat(header.format, value) }} 
                        </div>
  
                        <div v-if="header.format === 'link'"
                          class="cursor-pointer">
                          <div v-for="(menu, index) in item.menu_array" :key="index">
                            <div v-if="menu.status" class="d-flex align-center">
                              <v-chip
                                class="ma-2"
                                color="primary"
                                label
                                small
                              >
                                {{ menu.label }}
                              </v-chip>

                              <div v-if="menu.sub_menu.length > 0 && menu.status && menu.sub_menu.filter((sub) => sub.status).length > 0" class="d-flex align-center">
                                <v-icon
                                  size="15"
                                  :color="'black'">
                                  mdi-chevron-right
                                </v-icon>
                                <div v-for="(sub, idx) in menu.sub_menu" :key="idx" class="d-flex align-center">
                                  <div v-if="sub.status">
                                    <v-chip
                                      class="ma-2 white--text"
                                      :color="set_color"
                                      label
                                      small
                                    >
                                      {{ sub.label }}
                                    </v-chip>
                                  </div>

                                  <div v-if="sub.sub_menu.length > 0 && sub.status && sub.sub_menu.filter((sub2) => sub2.status).length > 0" class="d-flex align-center">
                                    <v-icon
                                      size="15"
                                      :color="'black'">
                                      mdi-chevron-right
                                    </v-icon>
                                    <div v-for="(sub2, idx2) in sub.sub_menu" :key="idx2" class="d-flex align-center">
                                      <div v-if="sub2.status">
                                        <v-chip
                                          class="ma-2 white--text"
                                          :color="set_color"
                                          label
                                          small
                                        >
                                          {{ sub2.label }}
                                        </v-chip>
                                      </div>

                                      <div v-if="sub2.sub_menu.length > 0 && sub2.status && sub2.sub_menu.filter((sub3) => sub3.status).length > 0" class="d-flex align-center">
                                        <v-icon
                                          size="15"
                                          :color="'black'">
                                          mdi-chevron-right
                                        </v-icon>
                                        <div v-for="(sub3, idx3) in sub2.sub_menu" :key="idx3" class="d-flex align-center">
                                          <div v-if="sub3.status">
                                            <v-chip
                                              class="ma-2 white--text"
                                              :color="set_color"
                                              label
                                              small
                                            >
                                              {{ sub3.label }}
                                            </v-chip>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>  
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
          
                        <div v-if="header.format === 'regex'">
                          <span
                            class="two-line">
                            {{ rowFormat(header.format, value) }}
                          </span>
                        </div>
          
                        <div v-if="header.format === 'image'"
                          class="ma-4">
                          <v-avatar
                            size="60"
                            tile
                            style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                            <v-img 
                              contain
                              width="100%"
                              height="100%"
                              alt="POS Amanata" 
                              :src="value !== '' ? value : require('@/assets/image/member_default.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    size="20"
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>
                        </div>
  
                        <div v-if="header.format === 'image_potrait'"
                          class="ma-4">
                          <v-img 
                            contain
                            width="100"
                            height="125"
                            alt="POS Amanata" 
                            :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                            class="ma-auto"
                            style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </div>
  
                        <div v-if="header.format === 'image_landscape'"
                          class="ma-4">
                          <v-img 
                            contain
                            width="200"
                            height="125"
                            alt="POS Amanata" 
                            :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                            class="ma-auto"
                            style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </div>
  
                        <div v-if="header.format === 'action'">
                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="reset(index); dialog.form = true;"
                                
                                v-bind="attrs"
                                v-on="on"
  
                                min-width="25"
                                height="25"
                                x-small
                                rounded
                                color="#3b3f5c"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 8px;">
                                <v-icon size="13">mdi-pencil-outline</v-icon>
                              </v-btn>
                            </template>
  
                            <span>Ubah</span>
                          </v-tooltip>
  
                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="toDelete(item.id)"
  
                                v-bind="attrs"
                                v-on="on"
  
                                min-width="25"
                                height="25"
                                x-small
                                rounded
                                color="#e7515a"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 8px;">
                                <v-icon size="13">mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </template>
                            
                            <span>Hapus</span>
                          </v-tooltip>
  
                          <!-- <v-menu
                            right
                            offset-y
                            style="box-shadow: none !important;">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
  
                                min-width="24" min-height="24"
                                x-small
                                rounded
                                color="#37474F"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="15">mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
  
                            <v-list
                              dense
                              color="#808080"
                              class="py-1 my-2"
                              style="border-radius: 10px !important;">
                              <v-list-item
                                class="px-2">
                                <v-tooltip 
                                  right>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      @click="toRole(value)"
  
                                      v-bind="attrs"
                                      v-on="on"
  
                                      min-width="24" min-height="24"
                                      x-small
                                      rounded
                                      color="indigo"
                                      elevation="0"
                                      class="white--text text-capitalize px-0"
                                      style="font-weight: 600; border-radius: 6px;">
                                      <v-icon small>mdi-account-settings-outline</v-icon>
                                    </v-btn>
                                  </template>
  
                                  <span>Hak Akses</span>
                                </v-tooltip>
                              </v-list-item>
  
                              <v-list-item
                                class="px-2">
                                <v-tooltip 
                                  right>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      @click="toReset(value)"
  
                                      v-bind="attrs"
                                      v-on="on"
                                      
                                      min-width="24" min-height="24"
                                      x-small
                                      rounded
                                      color="orange"
                                      elevation="0"
                                      class="white--text text-capitalize px-0"
                                      style="font-weight: 600; border-radius: 6px;">
                                      <v-icon size="15">mdi-lock-reset</v-icon>
                                    </v-btn>
                                  </template>
  
                                  <span>Reset Password</span>
                                </v-tooltip>
                              </v-list-item>
                            </v-list>
                          </v-menu> -->
                        </div>
  
                        <div v-if="header.format === 'bool'"
                          class="d-flex align-center justify-center">
                          <!-- <v-switch
                            @change="toStatus(value, index)"
                            v-model="value"
                            color="success"
                            class="ma-auto"
                            hide-details>
                          </v-switch> -->
                        </div>
  
                        <div v-if="header.format === 'status'"
                          class="d-flex justify-center">
                          
                        </div>
                      </div>
                    </template>
  
                    <template v-slot:[`item.index`]="{ index }">
                      {{ lastIndex + index }}
                    </template>
  
                    <v-progress-linear 
                      v-show="process.load" 
                      slot="progress" 
                      color="white" 
                      indeterminate>
                    </v-progress-linear>
                  </v-data-table>
                  <pagination v-if="pagination.total_data > 0"
                    @changePage="fetch($event)" 
                    @reloadPage="fetch($event)" 
                    :model="pagination" :display="paginationList"/>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          checkbox: false,
  
          dialog: {
            fullscreen: false,
            snackbar: false,
            freeze: false,
            hide: false,
  
            delete: false,
            reset: false,
            role: false,
  
            filter: false,
            form: false,
          },
          
          search: '',
  
          filter: {
            school_id: ''
          },

          menu: [
            {
              id: 1,
              label: 'Dashboard',
              icon: require('@/assets/icon/dashboard.png'),
              link: '/dashboard',
              active: true,
              status: false,
              is_child: true,
              sub_menu: [
                {
                  id: 2,
                  label: 'Statistik',
                  icon: require('@/assets/icon/grafik.png'),
                  link: '/dashboard',
                  active: false,
                  status: false,
                  is_child: false,
                  sub_menu: []
                },
                {
                  id: 3,
                  label: 'Monitoring',
                  icon: require('@/assets/icon/consultant.png'),
                  link: '/dashboard/monitoring',
                  active: false,
                  status: false,
                  is_child: false,
                  sub_menu: []
                },
                {
                  id: 4,
                  label: 'Audit Trail',
                  icon: require('@/assets/icon/audit.png'),
                  link: '/dashboard/audit-trail',
                  active: false,
                  status: false,
                  is_child: false,
                  sub_menu: []
                }
              ]
            },
            {
              id: 5,
              label: 'Master Data',
              icon: require('@/assets/icon/school.png'),
              link: '/sekolah',
              active: true,
              status: false,
              is_child: true,
              sub_menu: [
                {
                  id: 6,
                  label: 'Data Sekolah',
                  icon: require('@/assets/icon/school-gedung.png'),
                  link: '/sekolah/data-sekolah',
                  active: false,
                  status: false,
                  is_child: false,
                  sub_menu: []
                },
                {
                  id: 7,
                  label: 'Tahun Ajaran',
                  icon: require('@/assets/icon/calendar.png'),
                  link: '/sekolah/tahun-ajaran',
                  active: false,
                  status: false,
                  is_child: false,
                  sub_menu: []
                },
                {
                  id: 26,
                  label: 'Data Jabatan',
                  icon: require('@/assets/icon/employment.png'),
                  link: '/sekolah/jabatan',
                  active: false,
                  status: false,
                  is_child: false,
                  sub_menu: []
                },
                {
                  id: 27,
                  label: 'Hak Akses Guru & Pegawai',
                  icon: require('@/assets/icon/users.png'),
                  link: '/sekolah/hak-akses-guru-pegawai',
                  active: false,
                  status: false,
                  is_child: false,
                  sub_menu: []
                },
              ]
            },
            {
              id: 8,
              label: 'Manajemen Akademik',
              icon: require('@/assets/icon/learning.png'),
              link: '/manajemen-akademik',
              active: true,
              status: false,
              is_child: true,
              sub_menu: [
                {
                  id: 9,
                  label: 'Data Pengguna',
                  icon: require('@/assets/icon/instructor.png'),
                  link: '/manajemen-akademik/data-pengguna',
                  active: false,
                  status: false,
                  is_child: true,
                  sub_menu: [
                    {
                      id: 28,
                      label: 'Data Pegawai',
                      icon: require('@/assets/icon/instructor.png'),
                      link: '/manajemen-akademik/data-pengguna/data-guru-pegawai',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                    {
                      id: 12,
                      label: 'Data Siswa',
                      icon: require('@/assets/icon/instructor.png'),
                      link: '/manajemen-akademik/data-pengguna/data-siswa',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                    {
                      id: 13,
                      label: 'Data Wali Murid',
                      icon: require('@/assets/icon/instructor.png'),
                      link: '/manajemen-akademik/data-pengguna/data-wali-murid',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    }
                  ]
                },
                {
                  id: 10,
                  label: 'Kelas & Jadwal ',
                  icon: require('@/assets/icon/period.png'),
                  link: '/manajemen-akademik/kelas-jadwal',
                  active: false,
                  status: false,
                  is_child: true,
                  sub_menu: [
                    {
                      id: 14,
                      label: 'Data Kelas',
                      icon: require('@/assets/icon/period.png'),
                      link: '/manajemen-akademik/kelas-jadwal/kelola-kelas',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                    {
                      id: 18,
                      label: 'Mata Pelajaran',
                      icon: require('@/assets/icon/curriculum.png'),
                      link: '/manajemen-akademik/kelas-jadwal/daftar-mata-pelajaran',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                    {
                      id: 29,
                      label: 'Guru Pengampu',
                      icon: require('@/assets/icon/instructor.png'),
                      link: '/manajemen-akademik/kelas-jadwal/bidang-studi',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                    {
                      id: 15,
                      label: 'Jadwal Pembelajaran',
                      icon: require('@/assets/icon/period.png'),
                      link: '/manajemen-akademik/kelas-jadwal/jadwal-pembelajaran',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                    {
                      id: 16,
                      label: 'Kalender Akademik',
                      icon: require('@/assets/icon/period.png'),
                      link: '/manajemen-akademik/kelas-jadwal/kalender-akademik',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    }
                  ]
                },
                {
                  id: 17,
                  label: 'Kurikulum Sekolah',
                  icon: require('@/assets/icon/curriculum.png'),
                  link: '/manajemen-akademik/kurikulum-sekolah',
                  active: false,
                  status: false,
                  is_child: true,
                  sub_menu: [
                    {
                      id: 30,
                      label: 'Slide Banner',
                      icon: require('@/assets/icon/image_default.png'),
                      link: '/manajemen-akademik/kurikulum-sekolah/slide-banner',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                    {
                      id: 31,
                      label: 'Data Kurikulum',
                      icon: require('@/assets/icon/reference.png'),
                      link: '/manajemen-akademik/kurikulum-sekolah/informasi-kurikulum',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                    {
                      id: 19,
                      label: 'Upload & Kelola Modul ',
                      icon: require('@/assets/icon/curriculum.png'),
                      link: '/manajemen-akademik/kurikulum-sekolah/upload-kelola-modul',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                    // {
                    //   id: 19,
                    //   label: 'Upload & Kelola Modul ',
                    //   icon: require('@/assets/icon/curriculum.png'),
                    //   link: '/manajemen-akademik/kurikulum-sekolah/upload-kelola-modul',
                    //   active: false,
                    //   status: false,
                    //   is_child: false,
                    //   sub_menu: []
                    // },
                    // {
                    //   id: 31,
                    //   label: 'Informasi Kurikulum',
                    //   icon: require('@/assets/icon/reference.png'),
                    //   link: '/manajemen-akademik/kurikulum-sekolah/informasi-kurikulum',
                    //   active: false,
                    //   status: false,
                    //   is_child: false,
                    //   sub_menu: []
                    // },
                  ]
                },
                {
                  id: 26,
                  label: 'Buku Harian Kelas',
                  icon: require('@/assets/icon/timetable.png'),
                  link: '/manajemen-akademik/buku-harian-kelas',
                  active: false,
                  status: false,
                  is_child: false,
                  sub_menu: [
                    // {
                    //   id: 27,
                    //   label: 'Kehadiran Guru & Pegawai',
                    //   icon: require('@/assets/icon/dash_program.png'),
                    //   link: '/manajemen-akademik/kehadiran/kehadiran-guru-pegawai',
                    //   active: false,
                    //   status: false,
                    //   is_child: false,
                    //   sub_menu: []
                    // },
                    // {
                    //   id: 28,
                    //   label: 'Kehadiran Siswa',
                    //   icon: require('@/assets/icon/lembur.png'),
                    //   link: '/manajemen-akademik/kehadiran/kehadiran-siswa',
                    //   active: false,
                    //   status: false,
                    //   is_child: false,
                    //   sub_menu: []
                    // },
                    // {
                    //   id: 73,
                    //   label: 'Buku Harian Kelas',
                    //   icon: require('@/assets/icon/lembur.png'),
                    //   link: '/manajemen-akademik/kehadiran/buku-harian-kelas',
                    //   active: false,
                    //   status: false,
                    //   is_child: false,
                    //   sub_menu: []
                    // }
                  ]
                },
                {
                  id: 32,
                  label: 'Tugas & Penilaian',
                  icon: require('@/assets/icon/score.png'),
                  link: '/manajemen-akademik/tugas-penilaian',
                  active: false,
                  status: false,
                  is_child: true,
                  sub_menu: [
                    {
                      id: 33,
                      label: 'Daftar Tugas',
                      icon: require('@/assets/icon/score.png'),
                      link: '/manajemen-akademik/tugas-penilaian/daftar-tugas',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                    {
                      id: 34,
                      label: 'Exam (Ujian)',
                      icon: require('@/assets/icon/score.png'),
                      link: '/manajemen-akademik/tugas-penilaian/monitoring-tugas',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                    {
                      id: 35,
                      label: 'Rekap Nilai  ',
                      icon: require('@/assets/icon/score.png'),
                      link: '/manajemen-akademik/tugas-penilaian/input-rekap-nilai',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                  ]
                },
                {
                  id: 37,
                  label: 'Kegiatan Siswa',
                  icon: require('@/assets/icon/physical-education.png'),
                  link: '/manajemen-akademik/kegiatan-siswa',
                  active: false,
                  status: false,
                  is_child: true,
                  sub_menu: [
                    {
                      id: 38,
                      label: 'Data Kegiatan',
                      icon: require('@/assets/icon/physical-education.png'),
                      link: '/manajemen-akademik/kegiatan-siswa/data-kegiatan',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                    {
                      id: 39,
                      label: 'Jadwal Kegiatan',
                      icon: require('@/assets/icon/physical-education.png'),
                      link: '/manajemen-akademik/kegiatan-siswa/jadwal-kegiatan',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                    {
                      id: 40,
                      label: 'Rekap Kegiatan ',
                      icon: require('@/assets/icon/physical-education.png'),
                      link: '/manajemen-akademik/kegiatan-siswa/rekap-kegiatan',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                  ]
                },
                {
                  id: 41,
                  label: 'Komunikasi & Informasi',
                  icon: require('@/assets/icon/website.png'),
                  link: '/manajemen-akademik/komunikasi-informasi',
                  active: false,
                  status: false,
                  is_child: true,
                  sub_menu: [
                    {
                      id: 42,
                      label: 'Slide Banner',
                      icon: require('@/assets/icon/website.png'),
                      link: '/manajemen-akademik/komunikasi-informasi/slide-banner',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                    {
                      id: 43,
                      label: 'Pengumuman Sekolah',
                      icon: require('@/assets/icon/website.png'),
                      link: '/manajemen-akademik/komunikasi-informasi/pengumuman-sekolah',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                    {
                      id: 44,
                      label: 'Pesan Otomatis',
                      icon: require('@/assets/icon/website.png'),
                      link: '/manajemen-akademik/komunikasi-informasi/pesan-otomatis',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                  ]
                },
              ]
            },
            {
              id: 45,
              label: 'Portal Sekolah',
              icon: require('@/assets/icon/news.png'),
              link: '/portal-sekolah',
              active: true,
              status: false,
              is_child: true,
              sub_menu: [
                {
                  id: 46,
                  label: 'Informasi Sekolah',
                  icon: require('@/assets/icon/school-menu.png'),
                  link: '/portal-sekolah/informasi-sekolah',
                  active: false,
                  status: false,
                  is_child: true,
                  sub_menu: [
                    {
                      id: 47,
                      label: 'Berita & Artikel',
                      icon: require('@/assets/icon/school-menu.png'),
                      active: false,
                      status: false,
                      is_child: false,
                      link: '/portal-sekolah/informasi-sekolah/berita-artikel',
                      sub_menu: []
                    },
                    {
                      id: 48,
                      label: 'Agenda & Kegiatan',
                      icon: require('@/assets/icon/school-menu.png'),
                      active: false,
                      status: false,
                      is_child: false,
                      link: '/portal-sekolah/informasi-sekolah/agenda-kegiatan',
                      sub_menu: []
                    },
                    {
                      id: 49,
                      label: 'Profil Sekolah',
                      icon: require('@/assets/icon/school-menu.png'),
                      active: false,
                      status: false,
                      is_child: false,
                      link: '/portal-sekolah/informasi-sekolah/profil-sekolah',
                      sub_menu: [
                        {
                          id: 51,
                          label: 'Banner Sekolah',
                          icon: require('@/assets/icon/school-menu.png'),
                          link: '/portal-sekolah/informasi-sekolah/profil-sekolah/banner-sekolah',
                          active: false,
                          status: false,
                          is_child: false,
                          sub_menu: []
                        },
                        {
                          id: 52,
                          label: 'Visi & Misi',
                          icon: require('@/assets/icon/school-menu.png'),
                          link: '/portal-sekolah/informasi-sekolah/profil-sekolah/visi-misi',
                          active: false,
                          status: false,
                          is_child: false,
                          sub_menu: []
                        },
                        {
                          id: 53,
                          label: 'Struktur Organisasi',
                          icon: require('@/assets/icon/school-menu.png'),
                          link: '/portal-sekolah/informasi-sekolah/profil-sekolah/struktur-organisasi',
                          active: false,
                          status: false,
                          is_child: false,
                          sub_menu: []
                        },
                        {
                          id: 54,
                          label: 'Program & Kurikulum',
                          icon: require('@/assets/icon/school-menu.png'),
                          link: '/portal-sekolah/informasi-sekolah/profil-sekolah/program-kurikulum',
                          active: false,
                          status: false,
                          is_child: false,
                          sub_menu: []
                        },
                        {
                          id: 55,
                          label: 'Galeri & Kontak',
                          icon: require('@/assets/icon/school-menu.png'),
                          link: '/portal-sekolah/informasi-sekolah/profil-sekolah/galeri-kontak',
                          active: false,
                          status: false,
                          is_child: false,
                          sub_menu: []
                        },
                      ]
                    },
                    {
                      id: 50,
                      label: 'Ekstrakurikuler',
                      icon: require('@/assets/icon/school-menu.png'),
                      active: false,
                      status: false,
                      is_child: false,
                      link: '/portal-sekolah/informasi-sekolah/ekstrakurikuler',
                      sub_menu: []
                    },
                  ]
                },
                {
                  id: 56,
                  label: 'Portal Alumni',
                  icon: require('@/assets/icon/alumni.png'),
                  link: '/portal-sekolah/portal-alumni',
                  active: false,
                  status: false,
                  is_child: true,
                  sub_menu: [
                    {
                      id: 74,
                      label: 'Data Alumni',
                      icon: require('@/assets/icon/alumni.png'),
                      active: false,
                      status: false,
                      is_child: false,
                      link: '/portal-sekolah/portal-alumni/data-alumni',
                      sub_menu: []
                    },
                    {
                      id: 75,
                      label: 'Karir & Beasiswa',
                      icon: require('@/assets/icon/alumni.png'),
                      active: false,
                      status: false,
                      is_child: false,
                      link: '/portal-sekolah/portal-alumni/karir-beasiswa',
                      sub_menu: []
                    },
                    {
                      id: 76,
                      label: 'Forum Alumni',
                      icon: require('@/assets/icon/alumni.png'),
                      active: false,
                      status: false,
                      is_child: false,
                      link: '/portal-sekolah/portal-alumni/forum-alumni',
                      sub_menu: []
                    },
                  ]
                }
              ]
            },
            {
              id: 57,
              label: 'Tes Minat & Bakat',
              icon: require('@/assets/icon/talent-hunt.png'),
              link: '/tes-minat-bakat',
              active: true,
              status: false,
              is_child: true,
              sub_menu: [
                {
                  id: 58,
                  label: 'Kelola Tes',
                  icon: require('@/assets/icon/background-check.png'),
                  link: '/tes-minat-bakat/kelola-tes',
                  active: false,
                  status: false,
                  is_child: true,
                  sub_menu: []
                },
                {
                  id: 59,
                  label: 'Hasil Tes',
                  icon: require('@/assets/icon/report.png'),
                  link: '/tes-minat-bakat/hasil-tes',
                  active: false,
                  status: false,
                  is_child: true,
                  sub_menu: []
                },
                {
                  id: 60,
                  label: 'Analisa Potensi',
                  icon: require('@/assets/icon/talent-management.png'),
                  link: '/tes-minat-bakat/analisa-potensi',
                  active: false,
                  status: false,
                  is_child: true,
                  sub_menu: []
                },
                {
                  id: 61,
                  label: 'Rekomendasi Karir',
                  icon: require('@/assets/icon/recommendation.png'),
                  link: '/tes-minat-bakat/rekomendasi-karir',
                  active: false,
                  status: false,
                  is_child: true,
                  sub_menu: []
                },
                {
                  id: 62,
                  label: 'Konfigurasi Tes',
                  icon: require('@/assets/icon/settings.png'),
                  link: '/tes-minat-bakat/konfigurasi-tes',
                  active: false,
                  status: false,
                  is_child: true,
                  sub_menu: []
                }
              ]
            },
            {
              id: 63,
              label: 'Laporan & Analisa Data',
              icon: require('@/assets/icon/dash_persen.png'),
              link: '/laporan-analisa-data',
              active: true,
              status: false,
              is_child: true,
              sub_menu: [
                {
                  id: 64,
                  label: 'Laporan Bulanan Sekolah',
                  icon: require('@/assets/icon/profit.png'),
                  link: '/laporan-analisa-data/laporan-bulanan-sekolah',
                  active: false,
                  status: false,
                  is_child: false,
                  sub_menu: []
                },
                {
                  id: 65,
                  label: 'Rekap Keadaan Guru & Pegawai',
                  icon: require('@/assets/icon/classroom.png'),
                  link: '/laporan-analisa-data/rekap-keadaan-guru-pegawai',
                  active: false,
                  status: false,
                  is_child: false,
                  sub_menu: []
                },
                {
                  id: 66,
                  label: 'Laporan Kehadiran Siswa',
                  icon: require('@/assets/icon/immigration.png'),
                  link: '/laporan-analisa-data/laporan-kehadiran-siswa',
                  active: false,
                  status: false,
                  is_child: false,
                  sub_menu: []
                },
                {
                  id: 67,
                  label: 'Rekap Keadaan Siswa',
                  icon: require('@/assets/icon/students.png'),
                  link: '/laporan-analisa-data/rekap-keadaan-siswa',
                  active: false,
                  status: false,
                  is_child: false,
                  sub_menu: []
                },
                {
                  id: 68,
                  label: 'Talent Mapping',
                  icon: require('@/assets/icon/mind-mapping.png'),
                  link: '/laporan-analisa-data/talent-mapping',
                  active: false,
                  status: false,
                  is_child: true,
                  sub_menu: [
                    {
                      id: 69,
                      label: 'Analisa Wilayah',
                      icon: require('@/assets/icon/dash_persen.png'),
                      link: '/laporan-analisa-data/talent-mapping/analisa-wilayah',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                    {
                      id: 70,
                      label: 'Analisa Sekolah',
                      icon: require('@/assets/icon/dash_persen.png'),
                      link: '/laporan-analisa-data/talent-mapping/analisa-sekolah',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                    {
                      id: 71,
                      label: 'Tracer Study Alumni',
                      icon: require('@/assets/icon/dash_persen.png'),
                      link: '/laporan-analisa-data/talent-mapping/tracer-study-alumni',
                      active: false,
                      status: false,
                      is_child: false,
                      sub_menu: []
                    },
                  ]
                },
              ]
            }
          ],
  
          selected: {
            row: [],
            freeze: [],
            delete: [],
            reset: [],
            role: []
          },
  
          role: [],
  
          options: {},
          headers: [],
          list: [],
          pagination: {},
  
          lastIndex: 0,
          limit: 20,
  
          form: {
            id: '',
            category_name: '',
            school_id: '',
            menu_arr: []
          },

          school: [],

          process: {
            load: false,

            form: false,
            delete: false,
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
      },
      watch: {
        'options': {
          handler () {
            let pagination = { row: this.limit, page: 1 }
            
            this.fetch(pagination)
          },
          deep: true
        },
        '$store.state.school': function(val) {
          this.filter.school_id = val
          this.fetch()
        },
      },
      computed: {
        rps () {
          return this.$vuetify.breakpoint.name
        },
        user () {
          this.filter.school_id = this.$store.state.user.school_id === undefined || this.$store.state.user.school_id === null ? this.$store.state.school !== undefined && this.$store.state.school !== null && this.$store.state.school !== '' ? this.$store.state.school : '' : this.$store.state.user.school_id
          return this.$store.state.user
        },
        data_menu () {
          let menu = {}
          this.$store.state.menu.map((item, index) => {
            if (item.link.split('/')[1] === this.$route.path.split('/')[1]) {
              item.sub_menu.map((sub, index) => {
                if (sub.link === this.$route.path) {
                  menu = sub
                }
              })
            }
          })

          return menu
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        hak_akses () {
        let menu = {}
        // console.log(this.$store.state.menu)
        this.$store.state.menu.map(item => {
          if (item.id === 11) {
            menu = item
          }
        })
        return menu
      },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        },
  
        configHeaders () {
          return this.headers.filter(header => !header.hide)  
        }
      },
      mounted () {
        this.fetchSchool()
      },
      methods: {
        async fetchSchool() {

          let params = {
          limit: 10000000000000
        }

        await get(`school/data`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.school = res.results.data
          }
        })
      },
        rowFormat (format, value) {
          let data = value
  
          if (format === 'number') {
            if (isNaN(value)) return 'Not a Number'
            let price = ''
  
            const reverseNumber = value
              .toString()
              .split('')
              .reverse()
              .join('')
            const arrReverseNumber = [...Array(reverseNumber.length).keys()]
  
            arrReverseNumber.map(index => {
              if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
            })
  
            return `Rp ${
              price.split('', price.length - 1)
              .reverse()
              .join('')
            }`
          } else if (format === 'array') {
            let arr = []
  
            for (let i = 0; i < value.length; i++) {
              arr.push(value[i].label)
            }
  
            data = arr.join(', ')
          } else if (format === 'date') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
          } else if (format === 'time') {
            data = value.length > 0 ? moment(value).format('HH:mm') : '-'
          } else if (format === 'datetime') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
          } else if (format === 'object') {
            data = value.createdby.name
          } else if (format === 'regex') {
            let regex = /(<([^>]+)>)/ig
  
            data = value.replace(regex, '')
          } else if (format === 'underscore') {
            let regex = /_/g
  
            data = value.replace(regex, ' ')
          } else if (format === 'on_off') {
            data = value ? 'Online' : 'Offline'
          } else if (format === 'g_m') {
            data = value ? 'Mandiri' : 'Group'
          } else if (format === 'v_a') {
            data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
          } else if (format === 'y_n') {
            data = parseInt(value) ? 'Ya' : 'Tidak'
          } else if (format === 'percent') {
            data = Number(value) + ' %'
          } else if (format === 'action') {
            data = value
          } else if (format === 'bool') {
            data = value
          } else if (format === 'status') {
            data = value
          } else if (format === 'link') {
            data = value
          }  else {
            data = value ? 'Aktif' : 'Tidak Aktif'
          }
  
          return data
        },
        rowClick (item, row) {
          row.select(!row.isSelected ? true : false)
        },
        doubleClick (event, {item}) {
          // NO ACTION
        },
        handleToggleAll (event) {
          if (!event.value) this.selected.row = []
        },
  
        async fetch (pagination = { row: 20, page: 1 }) {
          this.process.load = true
  
          this.limit = pagination.row
  
          let params = {
            limit: pagination.row,
            page: pagination.page,
            sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
            order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
            search: this.search,
            school_id: this.filter.school_id,
          }
  
          this.selected.row = []
          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? `pegawai/category/data` : `pegawai_category/data`
  
          await get(`${url}`, { params })
          .then(response => {
            let res = response.data
  
            this.process.load = false
  
            this.list = []
            this.pagination = {}
              
            if (res.status === 200) {
              this.headers = [
                {
                  text: 'Aksi',
                  width: '120px',
                  value: 'id',
                  freeze: true,
                  hide: false,
                  align: 'center',
                  format: 'action'
                },
                // {
                //   text: 'Nomor Induk Pegawai',
                //   width: '200px',
                //   value: 'nip',
                //   freeze: false,
                //   hide: false
                // },
                {
                  text: 'Nama Role',
                  width: '200px',
                  value: 'category_name',
                  freeze: name,
                  hide: false,
                  sortable: true
                },
                {
                  text: 'Role',
                  width: '100%',
                  value: 'menu_arrray',
                  freeze: name,
                  hide: false,
                  sortable: true,
                  format: 'link'
                }
              ]
  
              this.list = res.results.data
              this.pagination = res.results.pagination
  
  
              this.lastIndex = (pagination.page - 1) * pagination.row 
              this.lastIndex += 1
  
              this.addFreezes()
  
              this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })
  
              if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
            }
          })
        },
  
        addFreezes () {
          this.removeFreezes()
  
          this.selected.freeze = []
  
          for (let i = 0; i < this.configHeaders.length; i++) {
            if (this.configHeaders[i].freeze) {
              // ADD TO SELECTOR
              this.selected.freeze.push({
                child: i + (this.checkbox ? 2 : 1),
                width: this.configHeaders[i].width.split('px')[0]
              })
  
              // LOOP STYLESHEET
              for (let f = 0; f < this.selected.freeze.length; f++) {
                let style = document.createElement('style'),
                    width = 0
  
                if (this.checkbox) {
                  width = f < 1 ? '65' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
                } else {
                  width = f < 1 ? '0' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
                }
  
                // ADD STYLESHET TO FREEZE
                style.innerHTML = `
                  .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 5;
                    background: #FFFFFF;
                  }
  
                  .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 1;
                  }
                `
  
                // ADD TO APPENDCHILD
                document.head.appendChild(style)
              }
            }
          }
        },
        removeFreezes () {
          // LOOP STYLESHEET
          for (let f = 0; f < this.selected.freeze.length; f++) {
            let style = document.createElement('style')
            
            // RESET STYLESHEET TO AUTO
            style.innerHTML = `
              .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
                background: #FFFFFF;
              }
  
              .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
              }
            `
  
            // ADD TO APPENDCHILD
            document.head.appendChild(style)
          }
        },
        addHides () {
          if (this.headers.length < 6) this.getTableToResize()
        },
        getTableToResize () {
          let tables = document.getElementsByTagName('table')
  
          for (let i = 0; i < tables.length; i++) {
            this.resizableGrid(tables[i])
          }
        },
        resizableGrid (table) {
          let row = table.getElementsByTagName('tr')[0],
              cols = row ? row.children : undefined
          
          if (!cols) return
          
          table.style.overflow = 'hidden'
          
          let tableHeight = table.offsetHeight
          
          for (let i = 0; i < cols.length; i++) {
            let div = createDiv(tableHeight)
            cols[i].appendChild(div)
            cols[i].style.position = 'relative'
  
            setListeners(div)
          }
  
          function setListeners (div) {
            let pageX, curCol, nxtCol, curColWidth, nxtColWidth
  
            div.addEventListener('mousedown', e => {
              curCol = e.target.parentElement
              nxtCol = curCol.nextElementSibling
              pageX = e.pageX
              
              let padding = paddingDiff(curCol)
              
              curColWidth = curCol.offsetWidth - padding
  
              if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
            })
  
            div.addEventListener ('mouseover', e => {
              e.target.style.borderRight = '2px solid #e0e0e0'
            })
  
            div.addEventListener ('mouseout', e => {
              e.target.style.borderRight = ''
            })
  
            document.addEventListener ('mousemove', e => {
              if (curCol) {
                let diffX = e.pageX - pageX
            
                if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'
  
                curCol.style.width = (curColWidth + diffX)+'px'
              }
            })
  
            document.addEventListener ('mouseup', () => { 
              curCol = undefined
              nxtCol = undefined
              pageX = undefined
              nxtColWidth = undefined
              curColWidth = undefined
            })
          }
  
          function createDiv (height) {
            let div = document.createElement('div')
  
            div.style.top = 0
            div.style.right = 0
            div.style.width = '1px'
            div.style.position = 'absolute'
            div.style.cursor = 'col-resize'
            div.style.userSelect = 'none'
            div.style.height = height + 'px'
            div.style.background = 'transparent'
  
            return div
          }
  
          function paddingDiff (col) {
            if (getStyleVal(col,'box-sizing') == 'border-box') {
              return 0
            }
            
            let padLeft = getStyleVal(col,'padding-left')
            let padRight = getStyleVal(col,'padding-right')
  
            return (parseInt(padLeft) + parseInt(padRight))
          }
  
          function getStyleVal (elm,css) {
            return (window.getComputedStyle(elm, null).getPropertyValue(css))
          }
        },
        reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: index !== undefined ? this.list[index].id : '',
          school_id: index !== undefined ? this.list[index].school_id : this.filter.school_id,
          category_name: index !== undefined ? this.list[index].category_name : '',
          menu_array: index !== undefined ? this.list[index].menu_array : []
        }

        this.menu.map((item, index) => {
          this.form.menu_array.map((sub, i) => {
            if (item.id === sub.id && sub.status) {
              item.status = true
            }
            
            if (item.sub_menu.length > 0) {
              item.sub_menu.map((sub_item, i) => {
                sub.sub_menu.map((sub_sub, i) => {
                  if (sub_item.id === sub_sub.id && sub_sub.status) {
                    sub_item.status = true
                  }

                  if (sub_item.sub_menu.length > 0) {
                    sub_item.sub_menu.map((sub_sub_item, i) => {
                      sub_sub.sub_menu.map((sub_sub_sub, i) => {
                        if (sub_sub_item.id === sub_sub_sub.id && sub_sub_sub.status) {
                          sub_sub_item.status = true
                        }

                        if (sub_sub_item.sub_menu.length > 0) {
                          sub_sub_item.sub_menu.map((sub_sub_sub_item, i) => {
                            sub_sub_sub.sub_menu.map((sub_sub_sub_sub, i) => {
                              if (sub_sub_sub_item.id === sub_sub_sub_sub.id && sub_sub_sub_sub.status) {
                                sub_sub_sub_item.status = true
                              }
                            })
                          })
                        }
                      })
                    })
                  }
                })
              })
            }
            
          })
        })

        this.process.form = false

        this.message.error = ''
      },
      async save () {
        this.form.tag = this.form.tag === null ? '' : this.form.tag
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true
          if (this.form.id !== '') {
            this.form = {
              id: this.form.id,
              school_id: this.form.school_id,
              category_name: this.form.category_name,
              menu_array: this.menu
            }
          } else {
            this.form = {
              category_name: this.form.category_name,
              school_id: this.form.school_id,
              menu_array: this.menu,
              id: this.form.id
            }
          }

          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? this.form.id === '' ? 'pegawai/category/add' : 'pegawai/category/update' : this.form.id === '' ? 'pegawai_category/add' : 'pegawai_category/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              if (this.form.id === '') {
                this.fetch()
              } else {
                this.fetch()
              }
              // this.fetchParent()
              this.reset()

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
  
        toDelete (id) {
          this.selected.delete = [id]
  
          this.dialog.delete = true
        },
        async deletes () {
          this.message.error = ''
  
          this.process.delete = true

          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? `pegawai/category/delete` : `pegawai_category/delete`
  
          await post(`${url}`, {
            data: {
              id: this.selected.delete[0],
              school_id: this.filter.school_id
            }
          }).then(response => {
            let res = response.data
  
            this.process.delete = false
  
            if (res.status === 200) {
  
              this.dialog.delete = false
  
              this.selected.row = []
              this.selected.delete = []
              
              this.dialog.snackbar = true
              this.message.success = res.message
  
              this.dialog.fullscreen = false
  
              this.fetch(this.paginationList)
            } else {
              this.message.error = res.message
            }
          })
        }
  
      }
    }
  </script>